<div fxLayout="row" fxLayoutAlign="center center">
    <div fxLayout="column" fxFlex="70%" fxFlex.sm="80%" fxFlex.md="80%" fxFlex.xs="90%"
      fxLayoutAlign="space-around stretch" fxLayoutGap="20px">
      <br />
      <br />
      <h1 i18n="@@accessibility-header" name="accessibility-header" class="mat-h1"><b>Accessibility</b></h1>
      <div class="accessibility-container" fxLayout.xs="column" fxLayout.sm="column" fxLayoutAlign="start start" fxLayoutGap="5%">
        <div fxLayout.xs="column" fxLayout.sm="column" fxLayout="row wrap" fxFlex="100%" fxLayoutAlign="space-evenly start" fxLayoutGap.xs="20px" fxLayoutGap.sm="20px">
            <mat-card fxFlex="45%" class="mat-elevation-z4 card-content">
                <mat-card-content fxLayout="column" fxLayoutGap="20px" class="content">
                    
                    <h3 i18n="@@title-standard-compliance" class="content-title" name="title-standard-compliance"><b>Standards Compliance</b></h3>
                    <p name="meet-w3c-guidelines">
                      <span i18n="@@meet-w3c-guidelines-1">At WEST 2, we are committed to ensuring our website is accessible to the widest possible audience. We strive to meet or exceed the </span>
                      <a i18n="@@accessibility-guidelines-link" class="accessibility-link" href="https://www.w3.org/WAI/standards-guidelines/wcag/">W3C Web Content Accessibility Guidelines (WCAG) 2.1 </a>
                      <span i18n="@@meet-w3c-guidelines-2">at Level AA. Whilst we endeavour to ensure all content is compliant, some learning materials adapted from original sources may not fully meet these standards.</span>
                    </p>                    
                    <h3 i18n="@@title-accessibility-reference" class="content-title" name="title-accessibility-reference"><b>Accessibility References</b></h3>
                    <ul class="accessibility-list">
                      <li>
                        <p name="accessibility-guidelines">
                          <a i18n="@@accessibility-guidelines-link" class="accessibility-link" href="https://www.w3.org/WAI/standards-guidelines/wcag/" target="_blank" name="accessibility-guidelines-link">W3C Web Content Accessibility Guidelines (WCAG) 2.1</a>
                          <span i18n="@@accessibility-guidelines-link-span" name="accessibility-guidelines-link-span">: Detailed explanations of each guideline and the reasons behind them.</span>
                        </p>
                      </li>
                      <li>
                        <p name="accessibility-techniques">
                          <a i18n="@@accessibility-techniques-link" class="accessibility-link" href="https://www.w3.org/WAI/WCAG22/quickref/" target="_blank" name="accessibility-techniques-link">W3C Techniques for WCAG 2.1</a>
                          <span i18n="@@accessibility-techniques-link-span" name="accessibility-techniques-link-span">: Practical advice on how to implement each guideline.</span>
                        </p>
                      </li>
                      <li>
                        <p name="accessibility-checklist">
                          <a i18n="@@accessibility-checklist-link" class="accessibility-link" href="http://www.w3.org/TR/WCAG10/full-checklist.html" target="_blank" name="accessibility-checklist-link">W3C Accessibility Checklist</a>
                          <span i18n="@@accessibility-checklist-link-span" name="accessibility-checklist-link-span">: A comprehensive guide for developers to ensure accessibility.</span>
                        </p>
                      </li>
                    </ul>

                    <h3 i18n="@@title-accessibility-software" class="content-title" name="title-accessibility-software"><b>Accessibility Tools and Software</b></h3>
                    <ul>
                      <li>
                        <p name="jaws">
                          <a class="accessibility-link" href="https://www.freedomscientific.com/Products/software/JAWS/" target="_blank" name="jaws-link">JAWS</a>
                          <span i18n="@@jaws-link-span" name="jaws-link-span">: A leading screen reader for Windows. A time-limited, downloadable demo is available.</span>
                        </p>
                      </li>
                      <li>
                        <p name="nvda">
                          <a class="accessibility-link" href="https://nvaccess.org/" target="_blank" name="nvda-link">NVDA (NonVisual Desktop Access)</a>
                          <span i18n="@@nvda-link-span" name="nvda-link-span">: A free, open-source screen reader for Windows.</span>
                        </p>
                      </li>
                      <li>
                        <p name="voice-over">
                          <a class="accessibility-link" href="https://www.apple.com/accessibility/vision/" target="_blank" name="voice-over-link">VoiceOver</a>
                          <span i18n="@@voice-over-link-span" name="voice-over-link-span">: A built-in screen reader for macOS and iOS.</span>
                        </p>
                      </li>
                      <li>
                        <p name="talk-back">
                          <span name="talk-back-link">TalkBack</span>
                          <span i18n="@@talk-back-link-span" name="talk-back-link-span">: A screen reader for Android devices.</span>
                        </p>
                      </li>
                      <li>
                        <p name="lynx">
                          <a class="accessibility-link" href="https://lynx.invisible-island.net/" target="_blank" name="lynx-link">Lynx</a>
                          <span i18n="@@lynx-link-span" name="lynx-link-span">: A text-only web browser useful for users with visual impairments who use refreshable Braille displays.</span>
                        </p>
                      </li>
                      <li>
                        <p name="opera">
                          <a class="accessibility-link" href="https://www.opera.com/" target="_blank" name="opera-link">Opera</a>
                          <span i18n="@@opera-link-span" name="opera-link-span">: A visual browser with accessibility features such as text zooming, user stylesheets, and image toggling. Available for Windows, macOS, Linux, and other operating systems.</span>
                        </p>
                      </li>
                    </ul>
                </mat-card-content>
            </mat-card>
            <mat-card fxFlex="45%" class="mat-elevation-z4 card-content">
                <mat-card-content fxLayout="column" fxLayoutGap="20px" class="content">
                  <h3 i18n="@@title-accessibility-services" class="content-title" name="title-accessibility-services"><b>Accessibility Services</b></h3>
                  <ul>
                    <li>
                      <p name="html-validator">
                        <a class="accessibility-link" href="https://validator.w3.org/" target="_blank" name="html-validator-link">W3C HTML Validator</a>
                        <span i18n="@@html-validator-link-span" name="html-validator-link-span">: A free service for checking that web pages conform to HTML standards.</span>
                      </p>
                    </li>
                    <li>
                      <p name="backward-compatibility-viewer">
                        <a i18n="@@backward-compatibility-viewer-link" class="accessibility-link" href="http://www.delorie.com/web/wpbcv.html" target="_blank" name="backward-compatibility-viewer-link">Web Page Backward Compatibility Viewer</a>
                        <span i18n="@@backward-compatibility-viewer-link-span" name="backward-compatibility-viewer-link-span">, a tool for viewing your web pages without a variety of modern browser features.</span>
                      </p>
                    </li>
                    <li>
                      <p name="lynx-viewer">
                        <a class="accessibility-link" href="https://addons.mozilla.org/en-US/firefox/addon/lynx-viewer/" target="_blank" name="lynx-viewer-link">Lynx Viewer</a>
                        <span i18n="@@lynx-viewer-link-span" name="lynx-viewer-link-span">: A service for viewing how web pages appear in the Lynx browser.</span>
                      </p>
                    </li>
                  </ul>

                  <h3 i18n="@@title-related-resources" class="content-title" name="title-related-resources"><b>Related Resources</b></h3>
                  <ul>
                    <li>
                      <p name="web-aim">
                        <a class="accessibility-link" href="https://webaim.org/" target="_blank" name="web-aim-link">WebAIM (Web Accessibility In Mind)</a>
                        <span i18n="@@web-aim-link-span" name="web-aim-link-span">: A non-profit organization focused on improving accessibility to online content.</span>
                      </p>
                    </li>
                    <li>
                      <p name="eleven-project">
                        <a i18n="@@eleven-project-link-title" class="accessibility-link" href="https://www.a11yproject.com/" target="_blank" name="web-aim-link">The A11Y Project</a>
                        <span i18n="@@eleven-project-link-span" name="eleven-project-link-span">: A community-driven effort to make digital accessibility easier.</span>
                      </p>
                    </li>
                    <li>
                      <p name="dive-accessibility">
                        <a i18n="@@dive-accessibility-link-title" class="accessibility-link" href="http://diveintoaccessibility.info/" target="_blank" name="dive-accessibility-link">Dive into Accessibility</a>
                        <span i18n="@@dive-accessibility-link-span" name="dive-accessibility-link-span">, an excellent practical guide to Web accessibility.</span>
                      </p>
                    </li>
                  </ul>

                  <h3 i18n="@@title-browser-compatibility" class="content-title" name="title-browser-compatibility"><b>Browser Compatibility</b></h3>
                  <p i18n="@@browser-compatibility-description" name="browser-compatibility-description">WEST 2 is designed and tested on the latest versions of major modern browsers. WEST 2 currently supports the following browsers:</p>
                  <ul>
                    <li>
                      <p name="microsoft-edge">
                        <a class="accessibility-link" href="https://www.microsoft.com/edge" target="_blank" name="microsoft-edge-link">Microsoft Edge</a>
                      </p>
                    </li>
                    <li>
                      <p name="google-chrome">
                        <a class="accessibility-link" name="google-chrome-link" href="https://www.google.com/chrome/" target="_blank">Google Chrome</a>
                      </p>
                    </li>
                    <li>
                      <p name="safari">
                        <a class="accessibility-link" href="https://www.apple.com/safari/" target="_blank" name="safari-link">Safari</a>
                      </p>
                    </li>
                  </ul>

                  <h3 i18n="@@title-accessibility-processes" class="content-title" name="title-accessibility-processes"><b>Accessibility Processes</b></h3>
                  <p i18n="@@accessibility-processes-description" name="accessibility-processes-description">WEST 2 implements the following processes to ensure its accessibility:</p>
                  <ul>
                    <li>
                      <p name="ap-description-one">
                        <span i18n="@@ap-description-one-span" name="ap-description-one-span">Accessibility forms part of our development roadmap.</span>
                      </p>
                    </li>
                    <li>
                      <p name="ap-description-two">
                        <span i18n="@@ap-description-two-span" name="ap-description-two-span">Accessibility is considered and implemented throughout the design and development process.</span>
                      </p>
                    </li>
                    <li>
                      <p name="ap-description-three">
                        <span i18n="@@ap-description-three-span" name="ap-description-three-span">Regularly review, discuss, and implement accessibility-focused development.</span>
                      </p>
                    </li>
                  </ul>
                </mat-card-content>
            </mat-card>
        </div>
      </div>
      <div *ngIf="isLoggedIn && (userProfile$ | async)?.roleId == learnerRole" class="browser-note">
        <app-browser-note></app-browser-note>
      </div>
    </div>
</div>
